<template>
	<div style="padding-bottom: 50px;">
		<!-- <div class="course mb-50 mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">直播预告</h3>
				<router-link tag="span" :to="{path:'/course?type='+3+'&name=zbyg&code='+propCode}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<LiveCourse :parentsData="dataProp" :name="'zbyg'"></LiveCourse>
		</div> -->
		<div class="course mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">专项课程</h3>
				<router-link tag="span" :to="{ path: '/course?type=6&name=zxkc&code=' + propCode }" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataZxClass" :name="'zxkc'"></GroupCourse>
		</div>
		<!-- <router-link tag="div" :to="{path:'/'}">
			<img src="../../../../static/del/pro.jpg" alt="">
		</router-link> -->
		<div class="course mt-20">
			<div class="flex-space title">
				<h3 class="fsm6">考点精讲</h3>
				<router-link tag="span" :to="{ path: '/course?type=6&name=kdjj&code=' + propCode }" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataKdClass" :name="'kdjj'"></GroupCourse>
		</div>
		<div class="course mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">习题练习</h3>
				<router-link tag="span" :to="{ path: '/course?type=6&name=xtlx&code=' + propCode }" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataXtClass" :name="'xtlx'"></GroupCourse>
		</div>
		<div class="course mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">学员心得</h3>
				<router-link tag="span" :to="{ path: '/course?type=5&code=' + propCode }" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<DataCourse :Data="dataXinde" :code="propCode"></DataCourse>
		</div>
	</div>
</template>

<script>
import LiveCourse from '@/components/Course/live.vue'
import GroupCourse from '@/components/Course/group.vue'
import DataCourse from '@/components/Course/xueyuan.vue'
export default {
	components: {
		LiveCourse,
		GroupCourse,
		DataCourse
	},
	props: {
		propTab: {
			type: Number,
			default: 1
		},
		dataProp: {
			type: Array,
			default: () => { return [] }
		},
		propCode: {
			type: String,
			default: ''
		},
		dataZxClass: {
			type: Object,
			default: () => { return {} }
		},
		dataKdClass: {
			type: Object,
			default: () => { return {} }
		},
		dataXtClass: {
			type: Object,
			default: () => { return {} }
		},
		dataXinde: {
			type: Array,
			default: () => { return [] }
		}
	},
	data() {
		return {

		}
	}
}
</script>

<style lang="less" scoped>
.course {
	.title {
		margin-bottom: 25px;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/index/components/class2.vue